<template>
  <div class="text-center py-8 px-4">
    <v-icon size="48" color="primary" class="mb-3">{{ icon }}</v-icon>
    <div class="text-h6 mb-1">{{ title }}</div>
    <p class="text-body-2 mx-auto mb-4" style="max-width: 520px">{{ body }}</p>

    <v-btn v-if="action" color="primary" class="ma-1" @click="$emit('action')">
      <v-icon left>{{ actionIcon }}</v-icon>
      {{ action }}
    </v-btn>
    <v-btn v-if="secondary" text color="primary" class="ma-1" :to="secondaryTo">
      <v-icon left>{{ secondaryIcon }}</v-icon>
      {{ secondary }}
    </v-btn>
  </div>
</template>

<script>
/*
 * What to do when there is nothing here yet.
 *
 * Every table in the panel said "No data available" and stopped. That is true
 * and useless: it does not say what the thing is, why a school would want one,
 * or how to make the first. A school setting itself up met that sentence on
 * eight screens in a row and had to guess the order to do them in.
 *
 * The same space now names the thing, says what it is for in one line, and
 * carries the button that makes one - so an empty screen teaches instead of
 * apologising.
 */
export default {
  name: "EmptyState",
  props: {
    icon: { type: String, default: "mdi-information-outline" },
    title: { type: String, required: true },
    body: { type: String, default: "" },
    action: { type: String, default: "" },
    actionIcon: { type: String, default: "mdi-plus" },
    secondary: { type: String, default: "" },
    secondaryIcon: { type: String, default: "mdi-file-upload-outline" },
    secondaryTo: { type: [Object, String], default: null },
  },
};
</script>
